module.exports = __webpack_public_path__ + "static/media/thrift-banner-mobile.24631be9.jpg";